import React from 'react';
import {RichTextarea} from 'components/vitrade-forms/common';

class ItemPayment extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      title: this.props.title,
      content: this.props.content
    };
  }

  onChange(name, e) {
    this.setState({[name]: e.target.value}, () => {
      this.props.updateItem(this.state, this.props.keyItem);
    });
  }

  render() {
    return (
      <div className="item-payment">
        <div className="content-justify item-payment-title-wrap">
          <h2 className="item-payment-title">Khối {this.props.keyItem+1}</h2>
          <button type="button" disabled={this.props.disabled} className="item-payment-btn-delete" onClick={this.props.removeItem}>Xóa khối</button>
        </div>
        <input type="text" className="item-payment-name" onChange={this.onChange.bind(this, 'title')} placeholder="Tên khối" name="title" value={this.state.title}/>
        <RichTextarea type="text" placeholder="Mô tả..."
          className="wrap-product-des"
          inputClassName="product-des-input"
          iconFontSet="glyphicon"
          iconClassName="glyphicon-user"
          value={this.state.content}
          name="content"
          onChange={this.onChange.bind(this, 'content')}
          required={true}
          bindValidator={this} channel="formPostProduct"
          errorMessage="Bạn vui lòng nhập mô tả ngắn"
        />
      </div>
    );
  }
}

export default ItemPayment;



// WEBPACK FOOTER //
// ./components/my-business/sub-view/payment/ItemPayment.jsx